import AirDrop from 'views/Activity'

const AirDropPage = () => {
  return <AirDrop />
}

AirDropPage.Layout = AirDropPage
// AirDropPage.mp = false

export default AirDropPage
